import { Flex, Text } from "@chakra-ui/react";

export default function CardExtract({description, value, bgColor, color}: any){
    return (
        <Flex
            w={"9.5vw"}
            h={"4vw"}
            bgColor={bgColor}
            flexDir={"column"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
            borderRadius={"8px"}
            color={color}
            textAlign="center"
            // A caixa tem largura fixa: sem recuo e sem quebra, descricao longa
            // (ex.: "Saldo do Split em: 28/07/2026") vazava para fora do card.
            px={2}
            overflow={"hidden"}
        >
            <Text
                textTransform={"uppercase"}
                fontSize={"0.6vw"}
                lineHeight={"1.2"}
                wordBreak={"break-word"}
            >{description}</Text>
            <Text fontSize={"1vw"} fontWeight={"bold"} whiteSpace={"nowrap"}>{value ? value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            }) : `R$ 0,00`}</Text>
        </Flex>
    )
}
